import { CUSTOM_PALETTE_ID_PREFIX } from '../constants/color-schemes';
import generateAlphaId from '../../common/helpers/generate-alpha-id';

const generateCustomPaletteId = () => `${CUSTOM_PALETTE_ID_PREFIX}${generateAlphaId()}`;

export default generateCustomPaletteId;
